<template>
  <v-dialog max-width="50%" v-model="showChecklistForm">
    <v-card>
      <v-card-title class="px-2 pt-4 py-0 d-flex">
        <v-row class="ma-0">
          <v-col cols="8" class="py-0">
            <v-tabs v-model="detailsTab" background-color="transparent" slider-color="primary" class="elevation-0"
              @change="onTabChange">
              <template v-if="!isChecklistSubmitted">
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon left small>mdi-truck-fast</v-icon>
                  Vehicle
                </v-tab>
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon left small>mdi-truck-trailer</v-icon>
                  Trailer
                </v-tab>
                <v-tab class="text-capitalize font-weight-medium" v-if="tripDetails && tripDetails.trailer_2">
                  <v-icon left small>mdi-truck-trailer</v-icon>
                  Trailer2
                </v-tab>
              </template>

              <!-- Show defect tabs for submitted but not passed checklist -->
              <template v-else>
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon left small>mdi-truck-fast</v-icon>
                  Vehicle Defects
                </v-tab>
                <v-tab class="text-capitalize font-weight-medium">
                  <v-icon left small>mdi-truck-trailer</v-icon>
                  Trailer Defects
                </v-tab>
                <v-tab class="text-capitalize font-weight-medium" v-if="tripDetails && tripDetails.trailer_2">
                  <v-icon left small>mdi-truck-trailer</v-icon>
                  Trailer2 Defects
                </v-tab>
              </template>
            </v-tabs>
          </v-col>
          <v-col cols="2" class="py-0 text-right align-self-center">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed icon v-bind="attrs" v-on="on">

                </v-btn>
              </template>
              <span>Checklist Download</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="py-0 text-right align-self-center">
            <v-btn icon @click="showChecklistForm = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider />
      <v-card-text class="white pa-0 rounded">
        <v-tabs-items v-model="detailsTab">
          <!-- Show regular checklist tabs if not submitted -->
          <template v-if="!isChecklistSubmitted">
            <!-- Vehicle Checklist -->
            <v-tab-item>
              <v-card-title>
                <v-col cols="8">
                  <span>Vehicle Checklist</span>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-checkbox v-model="selectAllStates.Vehicle" label="Select All"
                    @change="selectAllCheckListChanged('Vehicle')" />
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row v-for="(check, i) in vehicleChecklist" :key="i">
                  <v-col cols="8">
                    <v-icon color="primary" class="ml-2 mr-2">mdi-truck-fast</v-icon>
                    <span>
                      {{ check.name }}
                      <span v-if="check.is_mandatory == 'Yes'" class="text-red font-weight-bold">*</span>
                    </span>
                    <br />
                    <span class="text-caption ml-2">
                      Mandatory:
                      <v-chip :color="check.is_mandatory == 'Yes' ? 'red' : 'grey'"
                        :text-color="check.is_mandatory == 'Yes' ? 'white' : 'black'" x-small class="ml-1">
                        {{ check.is_mandatory == "Yes" ? "Yes" : "No" }}
                      </v-chip>
                    </span>
                  </v-col>
                  <v-col cols="4">
                    <v-switch v-model="check.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details
                      @change="updateSelectAllStates" />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn color="primary" :disabled="!canSubmitVehicleChecklist"
                  @click="submitSpecificChecklist('Vehicle')">
                  Submit Vehicle Checklist
                </v-btn> -->
              </v-card-actions>
            </v-tab-item>

            <!-- Trailer Checklist -->
            <v-tab-item>
              <v-card-title>
                <v-col cols="8">
                  <span>Trailer Checklist</span>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-checkbox v-model="selectAllStates.Trailer" label="Select All"
                    @change="selectAllCheckListChanged('Trailer')" />
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row v-for="(check, i) in trailerChecklist" :key="i">
                  <v-col cols="8">
                    <v-icon color="primary" class="ml-2 mr-2">mdi-truck-trailer</v-icon>
                    <span>
                      {{ check.name }}
                      <span v-if="check.is_mandatory == 'Yes'" class="text-red font-weight-bold">*</span>
                    </span>
                    <br />
                    <span class="text-caption ml-2">
                      Mandatory:
                      <v-chip :color="check.is_mandatory == 'Yes' ? 'red' : 'grey'"
                        :text-color="check.is_mandatory == 'Yes' ? 'white' : 'black'" x-small class="ml-1">
                        {{ check.is_mandatory == "Yes" ? "Yes" : "No" }}
                      </v-chip>
                    </span>
                  </v-col>
                  <v-col cols="4">
                    <v-switch v-model="check.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details
                      @change="updateSelectAllStates" />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn color="primary" :disabled="!canSubmitTrailerChecklist"
                  @click="submitSpecificChecklist('Trailer')">
                  Submit Trailer Checklist
                </v-btn> -->
              </v-card-actions>
            </v-tab-item>

            <!-- Trailer2 Checklist -->
            <v-tab-item>
              <v-card-title>
                <v-col cols="8">
                  <span>Trailer2 Checklist</span>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-checkbox v-model="selectAllStates.Trailer2" label="Select All"
                    @change="selectAllCheckListChanged('Trailer2')" />
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row v-for="(check, i) in trailer2Checklist" :key="`trailer2-${i}`">
                  <v-col cols="8">
                    <v-icon color="primary" class="ml-2 mr-2">mdi-truck-trailer</v-icon>
                    <span>
                      {{ check.name }}
                      <span v-if="check.is_mandatory == 'Yes'" class="text-red font-weight-bold">*</span>
                    </span>
                    <br />
                    <span class="text-caption ml-2">
                      Mandatory:
                      <v-chip :color="check.is_mandatory == 'Yes' ? 'red' : 'grey'"
                        :text-color="check.is_mandatory == 'Yes' ? 'white' : 'black'" x-small class="ml-1">
                        {{ check.is_mandatory == "Yes" ? "Yes" : "No" }}
                      </v-chip>
                    </span>
                  </v-col>
                  <v-col cols="4">
                    <v-switch v-model="check.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details
                      @change="() => { updateTrailer2Check(check._trailer2Index, check.is_checked); updateSelectAllStates(); }" />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn color="primary" :disabled="!canSubmitTrailer2Checklist"
                  @click="submitSpecificChecklist('Trailer2')">
                  Submit Trailer2 Checklist
                </v-btn> -->
              </v-card-actions>
            </v-tab-item>
          </template>

          <!-- Show defect tabs if checklist is submitted but not passed -->
          <template v-else>
            <!-- Vehicle Defects -->
            <v-tab-item>
              <v-card flat>
                <v-card-title>
                  <span>Vehicle Defects</span>
                </v-card-title>
                <v-card-text>
                  <v-progress-circular v-if="loading.vehicle" indeterminate color="primary"></v-progress-circular>
                  <v-simple-table v-else-if="currentDefectList.length > 0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Mandatory</th>
                        <th>
                          Checked
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="toggleSelectAllDefects">
                                mdi-checkbox-multiple-marked
                              </v-icon>
                            </template>
                            <span>Select / Deselect All</span>
                          </v-tooltip>
                        </th>
                        <th>Driver Remarks</th>
                        <th>
                          Admin Remarks
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="copyFirstRemarkToAll">
                                mdi-content-copy
                              </v-icon>
                            </template>
                            <span>Copy all</span>
                          </v-tooltip>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in currentDefectList" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>
                          <v-chip :color="item.is_mandatory ? 'red' : 'grey'" small dark>
                            {{ item.is_mandatory ? "Yes" : "No" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-switch v-model="item.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details />
                        </td>
                        <td>{{ item.driver_remarks }}</td>
                        <td>
                          <v-text-field v-model="item.admin_remarks" dense hide-details></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div v-else class="text-center pa-4">
                    <span class="text-muted">No defects found for this asset</span>
                  </div>
                </v-card-text>
                <v-card-actions v-if="currentDefectList.length > 0">
                  <v-btn color="orange" dark :disabled="!canSubmitVehicleDefects" @click="submitDefects('vehicle')">
                    Submit Vehicle Defects
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>

            <!-- Trailer Defects -->
            <v-tab-item>
              <v-card flat>
                <v-card-title>
                  <span>Trailer Defects</span>
                </v-card-title>
                <v-card-text>
                  <v-progress-circular v-if="loading.trailer" indeterminate color="primary"></v-progress-circular>
                  <v-simple-table v-else-if="currentDefectList.length > 0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Mandatory</th>
                        <th>
                          Checked
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="toggleSelectAllDefects">
                                mdi-checkbox-multiple-marked
                              </v-icon>
                            </template>
                            <span>Select / Deselect All</span>
                          </v-tooltip>
                        </th>
                        <th>Driver Remarks</th>
                        <th>
                          Admin Remarks
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="copyFirstRemarkToAll">
                                mdi-content-copy
                              </v-icon>
                            </template>
                            <span>Copy all</span>
                          </v-tooltip>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in currentDefectList" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>
                          <v-chip :color="item.is_mandatory ? 'red' : 'grey'" small dark>
                            {{ item.is_mandatory ? "Yes" : "No" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-switch v-model="item.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details />
                        </td>
                        <td>{{ item.driver_remarks }}</td>
                        <td>
                          <v-text-field v-model="item.admin_remarks" dense hide-details></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div v-else class="text-center pa-4">
                    <span class="text-muted">No defects found for this asset</span>
                  </div>
                </v-card-text>
                <v-card-actions v-if="currentDefectList.length > 0">
                  <v-btn color="orange" dark :disabled="!canSubmitTrailerDefects" @click="submitDefects('trailer')">
                    Submit Trailer Defects
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>

            <!-- Trailer2 Defects -->
            <v-tab-item>
              <v-card flat>
                <v-card-title>
                  <span>Trailer2 Defects</span>
                </v-card-title>
                <v-card-text>
                  <v-progress-circular v-if="loading.trailer2" indeterminate color="primary"></v-progress-circular>
                  <v-simple-table v-else-if="currentDefectList.length > 0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Mandatory</th>
                        <th>
                          Checked
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="toggleSelectAllDefects">
                                mdi-checkbox-multiple-marked
                              </v-icon>
                            </template>
                            <span>Select / Deselect All</span>
                          </v-tooltip>
                        </th>
                        <th>Driver Remarks</th>
                        <th>
                          Admin Remarks
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="blue" class="ml-2 cursor-pointer" v-bind="attrs" v-on="on"
                                @click="copyFirstRemarkToAll">
                                mdi-content-copy
                              </v-icon>
                            </template>
                            <span>Copy all</span>
                          </v-tooltip>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in currentDefectList" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>
                          <v-chip :color="item.is_mandatory ? 'red' : 'grey'" small dark>
                            {{ item.is_mandatory ? "Yes" : "No" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-switch v-model="item.is_checked" :true-value="'Yes'" :false-value="'No'" hide-details />
                        </td>
                        <td>{{ item.driver_remarks }}</td>
                        <td>
                          <v-text-field v-model="item.admin_remarks" dense hide-details></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div v-else class="text-center pa-4">
                    <span class="text-muted">No defects found for this asset</span>
                  </div>
                </v-card-text>
                <v-card-actions v-if="currentDefectList.length > 0">
                  <v-btn color="orange" dark :disabled="!canSubmitTrailer2Defects" @click="submitDefects('trailer2')">
                    Submit Trailer2 Defects
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </template>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions class="d-flex justify-end px-3 py-1">
        <v-btn v-if="!isChecklistSubmitted" color="primary" :disabled="!canSubmitAllChecklists"
          @click="submitTripChecklist">
          Submit All Checklists
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripDetails: {
      type: Object,
      default: null,
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    SubmittedCheckListData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      detailsTab: 0,
      selectAllStates: {
        Vehicle: false,
        Trailer: false,
        Trailer2: false,
      },
      vehicleDefectList: [],
      trailerDefectList: [],
      trailer2DefectList: [],
      loading: {
        vehicle: false,
        trailer: false,
        trailer2: false,
      },
      currentAssetType: 'vehicle',
      isDialogReopened: false,
      selectAllChecked: false,
    };
  },

  computed: {
    showChecklistForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    isChecklistSubmitted() {
      return this.tripDetails && this.tripDetails.is_checklist_submitted === "Yes";
    },

    currentDefectList() {
      if (!this.isChecklistSubmitted) return [];

      const tabMapping = ['vehicle', 'trailer', 'trailer2'];
      const currentAssetType = tabMapping[this.detailsTab] || 'vehicle';

      switch (currentAssetType) {
        case 'vehicle':
          return this.vehicleDefectList;
        case 'trailer':
          return this.trailerDefectList;
        case 'trailer2':
          return this.trailer2DefectList;
        default:
          return [];
      }
    },

    vehicleChecklist() {
      return this.checkList.filter((item) => item.asset_type === "Vehicle");
    },

    trailerChecklist() {
      return this.checkList.filter((item) => item.asset_type === "Trailer");
    },

    trailer2Checklist() {
      const trailerItems = this.checkList.filter((item) => item.asset_type === "Trailer");
      return trailerItems.map((item, index) => ({
        ...item,
        _isTrailer2: true,
        _trailer2Index: index,
        is_checked: item.is_checked_trailer2 || "No",
        // Ensure we're using the trailer2 specific checked value
        is_mandatory: item.is_mandatory
      }));
    },

    // Individual checklist validation
    canSubmitVehicleChecklist() {
      if (this.vehicleChecklist.length === 0) return false;
      return this.vehicleChecklist.every(item => {
        if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
          return item.is_checked === "Yes" || item.is_checked === true;
        }
        return true;
      });
    },

    canSubmitTrailerChecklist() {
      if (this.trailerChecklist.length === 0) return false;
      return this.trailerChecklist.every(item => {
        if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
          return item.is_checked === "Yes" || item.is_checked === true;
        }
        return true;
      });
    },

    canSubmitTrailer2Checklist() {
      if (this.trailer2Checklist.length === 0) return false;
      return this.trailer2Checklist.every(item => {
        if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
          return item.is_checked === "Yes" || item.is_checked === true;
        }
        return true;
      });
    },

    // All checklists validation - only check if items exist
    canSubmitAllChecklists() {
      let hasValidItems = false;
      let allMandatoryChecked = true;

      // Check Vehicle
      if (this.vehicleChecklist.length > 0) {
        hasValidItems = true;
        const vehicleValid = this.vehicleChecklist.every(item => {
          if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
            return item.is_checked === "Yes" || item.is_checked === true;
          }
          return true;
        });
        allMandatoryChecked = allMandatoryChecked && vehicleValid;
      }

      // Check Trailer
      if (this.trailerChecklist.length > 0) {
        hasValidItems = true;
        const trailerValid = this.trailerChecklist.every(item => {
          if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
            return item.is_checked === "Yes" || item.is_checked === true;
          }
          return true;
        });
        allMandatoryChecked = allMandatoryChecked && trailerValid;
      }

      // Check Trailer2 (only if it exists)
      if (this.tripDetails && this.tripDetails.trailer_2 && this.trailer2Checklist.length > 0) {
        hasValidItems = true;
        const trailer2Valid = this.trailer2Checklist.every(item => {
          if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
            return item.is_checked === "Yes" || item.is_checked === true;
          }
          return true;
        });
        allMandatoryChecked = allMandatoryChecked && trailer2Valid;
      }

      return hasValidItems && allMandatoryChecked;
    },

    // Individual defect validation
    canSubmitVehicleDefects() {
      if (!this.isChecklistSubmitted || this.detailsTab !== 0) return false;
      return this.canSubmitDefectsForList(this.vehicleDefectList);
    },

    canSubmitTrailerDefects() {
      if (!this.isChecklistSubmitted || this.detailsTab !== 1) return false;
      return this.canSubmitDefectsForList(this.trailerDefectList);
    },

    canSubmitTrailer2Defects() {
      if (!this.isChecklistSubmitted || this.detailsTab !== 2) return false;
      return this.canSubmitDefectsForList(this.trailer2DefectList);
    }
  },

  watch: {
    checkList: {
      handler() {
        this.updateSelectAllStates();
      },
      deep: true,
    },
    currentDefectList: {
      handler() {
        this.updateSelectAllState();
      },
      deep: true,
    },
    showChecklistForm(newVal) {
      if (newVal && this.isChecklistSubmitted) {
        this.detailsTab = 0;
        this.isDialogReopened = true;
        this.loadDefectDataForTab(0);
      } else if (!newVal) {
        this.isDialogReopened = false;
      }
    }
  },

  methods: {
    canSubmitDefectsForList(defectList) {
      if (!defectList || defectList.length === 0) return false;

      const mandatoryChecked = defectList.every(item => {
        if (item.is_mandatory === "Yes" || item.is_mandatory === true) {
          return item.is_checked === "Yes" || item.is_checked === true;
        }
        return true;
      });

      const allHaveRemarks = defectList.every(item => item.admin_remarks && item.admin_remarks.trim() !== "");

      return mandatoryChecked && allHaveRemarks;
    },

    onTabChange(tabIndex) {
      if (this.isChecklistSubmitted) {
        this.loadDefectDataForTab(tabIndex);
      }
    },

    loadDefectDataForTab(tabIndex) {
      const tabMapping = ['vehicle', 'trailer', 'trailer2'];
      const assetType = tabMapping[tabIndex] || 'vehicle';
      this.currentAssetType = assetType;

      const existingData = this.getDefectListByAssetType(assetType);

      if (this.isDialogReopened || existingData.length === 0) {
        this.getDefectAssetChecklistData(assetType);
      }
    },

    getDefectListByAssetType(assetType) {
      switch (assetType) {
        case 'vehicle':
          return this.vehicleDefectList;
        case 'trailer':
          return this.trailerDefectList;
        case 'trailer2':
          return this.trailer2DefectList;
        default:
          return [];
      }
    },

    getDefectAssetChecklistData(assetType = 'vehicle') {
      this.loading[assetType] = true;

      const baseParams = {
        limit: "all",
        asset_type: assetType,
        checklist_submitted_on: this.tripDetails.checklist_submitted_on
      };

      let params = { ...baseParams };

      switch (assetType) {
        case 'vehicle':
          params.vehicle = this.tripDetails.vehicle;
          break;
        case 'trailer':
          params.trailer = this.tripDetails.trailer_1;
          break;
        case 'trailer2':
          params.trailer2 = this.tripDetails.trailer_2;
          break;
      }

      this.$api.vehicle
        .getDefectAssetChecklist(params)
        .then((res) => {
          const defectData = res.data
            .flatMap((entry) => entry.defect_asset_checklist_items || [])
            .filter((item) => item.is_checked === "No");

          switch (assetType) {
            case 'vehicle':
              this.vehicleDefectList = defectData;
              break;
            case 'trailer':
              this.trailerDefectList = defectData;
              break;
            case 'trailer2':
              this.trailer2DefectList = defectData;
              break;
          }

          this.loading[assetType] = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading[assetType] = false;
        });
    },

    selectAllCheckListChanged(assetType) {
      const newValue = this.selectAllStates[assetType] ? "Yes" : "No";
      if (assetType === 'Vehicle') {
        this.vehicleChecklist.forEach((c) => {
          c.is_checked = newValue;
        });
      } else if (assetType === 'Trailer') {
        this.trailerChecklist.forEach((c) => {
          c.is_checked = newValue;
        });
      } else if (assetType === 'Trailer2') {
        const originalTrailerItems = this.checkList.filter((item) => item.asset_type === "Trailer");
        originalTrailerItems.forEach((item) => {
          this.$set(item, 'is_checked_trailer2', newValue);
        });
        // Force reactivity update
        this.$forceUpdate();
      }
    },

    updateSelectAllStates() {
      if (this.vehicleChecklist.length > 0) {
        this.selectAllStates.Vehicle = this.vehicleChecklist.every(
          (item) => item.is_checked === "Yes"
        );
      }

      if (this.trailerChecklist.length > 0) {
        this.selectAllStates.Trailer = this.trailerChecklist.every(
          (item) => item.is_checked === "Yes"
        );
      }

      const originalTrailerItems = this.checkList.filter((item) => item.asset_type === "Trailer");
      if (originalTrailerItems.length > 0) {
        this.selectAllStates.Trailer2 = originalTrailerItems.every(
          (item) => (item.is_checked_trailer2 || "No") === "Yes"
        );
      }
    },

    updateTrailer2Check(index, value) {
      const originalTrailerItems = this.checkList.filter((item) => item.asset_type === "Trailer");
      if (originalTrailerItems[index]) {
        this.$set(originalTrailerItems[index], 'is_checked_trailer2', value);
      }
      this.updateSelectAllStates();
    },

    submitSpecificChecklist(assetType) {
      let checklist = [];
      let assetId = null;
      let assetNumber = null;
      let canSubmit = false;

      switch (assetType) {
        case 'Vehicle':
          checklist = this.vehicleChecklist;
          assetId = this.tripDetails.vehicle;
          assetNumber = this.tripDetails.vehicle_number;
          canSubmit = this.canSubmitVehicleChecklist;
          break;
        case 'Trailer':
          checklist = this.trailerChecklist;
          assetId = this.tripDetails.trailer_1;
          assetNumber = this.tripDetails.trailer_1_number;
          canSubmit = this.canSubmitTrailerChecklist;
          break;
        case 'Trailer2':
          checklist = this.trailer2Checklist.map(item => ({
            ...item,
            is_checked: item.is_checked
          }));
          assetId = this.tripDetails.trailer_2;
          assetNumber = this.tripDetails.trailer_2_number;
          canSubmit = this.canSubmitTrailer2Checklist;
          break;
      }

      if (!canSubmit) {
        this.$bus.$emit("showToastMessage", {
          message: `Please check all mandatory items for ${assetType} before submitting.`,
          color: "error",
        });
        return;
      }

      const createPayloadForChecklist = (checklist, assetType, assetId, assetNumber) => {
        return checklist.length > 0
          ? [{
            vehicle: assetType === "Vehicle" ? assetId : null,
            trailer: assetType === "Trailer" || assetType === "Trailer2" ? assetId : null,
            date: new Date().toISOString().split("T")[0],
            trip: this.tripDetails.id,
            checklist_submitted: "Yes",
            items: checklist.map((item) => ({
              checklist: item.id,
              name: item.name,
              arabic_name: item.arabic_name || null,
              is_mandatory: item.is_mandatory === "Yes" || item.is_mandatory === true,
              remarks: item.remarks || null,
              is_checked: item.is_checked === "Yes" || item.is_checked === true,
            })),
          }]
          : [];
      };

      const payload = createPayloadForChecklist(checklist, assetType, assetId, assetNumber);

      this.$api.vehicle
        .addAssetCheckList(payload)
        .then((res) => {
          this.$emit("refreshList");
          this.$bus.$emit("showToastMessage", {
            message: `${assetType} checklist submitted successfully!`,
            color: "success",
          });
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message: err.data && err.data.non_field_errors
              ? err.data.non_field_errors[0]
              : `Couldn't submit ${assetType} checklist!`,
            color: "error",
          });
        });
    },

    submitTripChecklist() {
      if (!this.canSubmitAllChecklists) {
        this.$bus.$emit("showToastMessage", {
          message: "Please check all mandatory items before submitting.",
          color: "error",
        });
        return;
      }

      const createPayloadForChecklist = (checklist, assetType, assetId, assetNumber) => {
        return checklist.length > 0
          ? [{
            vehicle: assetType == "vehicle" ? assetId : null,
            trailer: assetType == "trailer" ? assetId : null,
            date: new Date().toISOString().split("T")[0],
            trip: this.tripDetails.id,
            checklist_submitted: "Yes",
            items: checklist.map((item) => ({
              checklist: item.id,
              name: item.name,
              arabic_name: item.arabic_name || null,
              is_mandatory: item.is_mandatory === "Yes" || item.is_mandatory === true,
              remarks: item.remarks || null,
              is_checked: item.is_checked === "Yes" || item.is_checked === true,
            })),
          }]
          : [];
      };

      const payload = [
        ...createPayloadForChecklist(
          this.vehicleChecklist,
          "vehicle",
          this.tripDetails.vehicle,
          this.tripDetails.vehicle_number
        ),
        ...createPayloadForChecklist(
          this.trailerChecklist,
          "trailer",
          this.tripDetails.trailer_1,
          this.tripDetails.trailer_1_number
        ),
        ...(this.tripDetails.trailer_2
          ? createPayloadForChecklist(
            this.trailer2Checklist.map(item => ({
              ...item,
              is_checked: item.is_checked
            })),
            "trailer",
            this.tripDetails.trailer_2,
            this.tripDetails.trailer_2_number
          )
          : []),
      ];

      this.$api.vehicle
        .addAssetCheckList(payload)
        .then((res) => {
          this.showChecklistForm = false;
          this.$emit("refreshList");
          this.$bus.$emit("showToastMessage", {
            message: "All checklists submitted successfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message: err.data && err.data.non_field_errors
              ? err.data.non_field_errors[0]
              : "Couldn't submit checklists!",
            color: "error",
          });
        });
    },

    toggleSelectAllDefects() {
      const allChecked = this.currentDefectList.every(
        (item) => item.is_checked === "Yes"
      );
      const newValue = allChecked ? "No" : "Yes";
      this.currentDefectList.forEach((item) => {
        item.is_checked = newValue;
      });
    },

    copyFirstRemarkToAll() {
      if (!this.currentDefectList.length) return;
      const firstRemark = this.currentDefectList[0].admin_remarks || "";
      this.currentDefectList.forEach((item) => {
        item.admin_remarks = firstRemark;
      });
    },

    updateSelectAllState() {
      const allChecked = this.currentDefectList.every(
        (item) => item.is_checked === "Yes"
      );
      const noneChecked = this.currentDefectList.every(
        (item) => item.is_checked === "No"
      );

      if (allChecked) {
        this.selectAllChecked = true;
      } else if (noneChecked) {
        this.selectAllChecked = false;
      }
    },

    // Submit defect checklist
    submitDefects(assetType) {
      const payload = {
        trip_id: this.tripDetails.id,
        asset_type: assetType,
        checklist_submitted: this.tripDetails.is_checklist_submitted,
        checklists: this.currentDefectList.map((checklist) => ({
          id: checklist.defect_checklist_id,
          items: [{
            id: checklist.id,
            is_checked: checklist.is_checked === "Yes" ? true : false,
            admin_remarks: checklist.admin_remarks,
          }],
        })),
      };

      this.$api.vehicle
        .addDefectAssetCheckList(payload)
        .then((res) => {
          this.$emit("refreshList");
          this.showChecklistForm = false;
          this.$bus.$emit("showToastMessage", {
            message: "Defect checklist submitted successfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Could not submit defect checklist !",
            color: "error",
          });
        });
    },
  },

  mounted() {
    this.updateSelectAllStates();
  },
};
</script>